import Model, { attr } from '@ember-data/model';

export default class CampaignLineItemModel extends Model {
  @attr('string') lineItemId?: string;
  @attr('string') campaignId?: string;
  @attr('string') hostCampaignId?: string;
  @attr('boolean') approved!: boolean;
  @attr('number') amount!: number;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'campaign-line-item': CampaignLineItemModel;
  }
}
